import { paymentsApi } from '.';

export interface PaypalProviderConfig {
  account_identifier: string,
  client_id: string,
  client_environment: string,
}

export interface StripeProviderConfig {
  public_key: string,
  account_identifier: string,
}

export interface BraintreeProviderConfig {
  account_identifier: string,
  mode?: string,
}

export interface BraintreeGooglepayProviderConfig {
  account_identifier: string,
  google_merchant_id?: string,
  mode?: string,
}

export interface BraintreeApplepayProviderConfig {
  account_identifier: string,
  mode?: string,
}

export type ProviderTypeConfig =
  PaypalProviderConfig
  | StripeProviderConfig
  | BraintreeProviderConfig
  | BraintreeGooglepayProviderConfig
  | BraintreeApplepayProviderConfig;

export interface PaymentsConfigData {
  dependencies: {
    gtm: boolean,
    plus: boolean,
    sentry: boolean,
    reCaptcha: boolean,
    reCaptcha_frontend: boolean,
    defender: boolean,
  },
  provider: {
    single: {
      DUMMY: object,
      PAYPAL: PaypalProviderConfig,
      STRIPE: StripeProviderConfig,
      BRAINTREE: BraintreeProviderConfig,
      BRAINTREE_GOOGLEPAY: BraintreeGooglepayProviderConfig,
      BRAINTREE_APPLEPAY: BraintreeApplepayProviderConfig,
    },
    monthly: {
      GOCARDLESS: object,
    },
    // Aligns with the providers rendered within /features/payin/PayinPaymentForm.tsx, although...
    // TO-DO: serverless-payments-bootstrap needs to be updated to support this
    // within the isProviderAvailable context
    payin: {
      STRIPE: StripeProviderConfig,
      // We don't use Braintree for Payin, but including here as a prompt to reassess if we need to:
      // BRAINTREE: BraintreeProviderConfig,
    },
    direct: {
      STRIPE: StripeProviderConfig,
      BRAINTREE: BraintreeProviderConfig,
      BRAINTREE_GOOGLEPAY: BraintreeGooglepayProviderConfig,
      BRAINTREE_APPLEPAY: BraintreeApplepayProviderConfig,
    },
  },
  redirect: {
    active: boolean,
    url: string,
  },
}

export interface PaymentsConfigResponse {
  data: PaymentsConfigData,
  message: string,
}

const extendedPaymentsApi = paymentsApi.injectEndpoints({
  endpoints: builder => ({
    getPaymentsConfig: builder.query<PaymentsConfigResponse, { clientId: string, allProviders?: boolean }>({
      query: ({ clientId, allProviders = false }) => `provider?client=${clientId}&all-providers=${Number(allProviders)}`
    })
  })
});

export const { useGetPaymentsConfigQuery } = extendedPaymentsApi;
